import { ContentComputer } from './ContentComputer';

/**
 * A dummy store that doesn't store anything.
 */
export const dummyContentComputerStore = {
    getDocument: async () => {
        // noop
        return undefined;
    },
    setDocument: async () => {
        // noop
    },
    getRevision: async () => {
        // noop
        return undefined;
    },
    setRevision: async () => {
        // noop
    },
};

/**
 * Dummy content computer that throw an error when trying to compute.
 */
export const dummyContentComputer = new ContentComputer({
    context: {
        runComputeDocument: async () => {
            throw new Error('Dummy content computer cannot compute');
        },
        runComputeRevision: async () => {
            throw new Error('Dummy content computer cannot compute');
        },
        getSourceVersion: async () => {
            throw new Error('Dummy content computer cannot compute');
        },
        resolveDependency: () => {
            throw new Error('Dummy content computer cannot compute');
        },
        touchDependency: () => {
            throw new Error('Dummy content computer cannot compute');
        },
    },
    store: dummyContentComputerStore,
});
